import React, { useState, useEffect } from "react";
import { dateCalculation } from "../../../utils";
import "./styles.css";
import { AgChartsReact } from "ag-charts-react";

function formatAssetStrings(data) {
  const dealTypeToColor = {
    'EARLY_BIRD': '#27AE5F',
    'LAST_MINUTE': '#FED533',
    'SEAT_LEVEL': '#58CCDE',
    'FLAT_DEAL': '#B3325D',
    'NEW_USER': '#EB5757',
    // Add more deal types and colors as needed
  };

  return data.map((item, index) => (
    <div key={index} className="dealSummaryContainer">
      <div
        style={{
          backgroundColor: dealTypeToColor[item.asset] || '#CCCCCC',
          padding: '6px',
          margin: '3px 12px 10px 0',
          cursor: 'pointer'
        }}
      ></div>
      <div className="assetItem">{`${transformLabel(item.asset)}`}</div>
      <div className="assetPercent">{`(${(item.percent)}%)`}</div>
    </div>
  ));
}

const transformLabel = (label) => {
  let data = label
    .toLowerCase()
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

    if (!data.endsWith("Deal")) {
      data += " Deal";
    }
    if(data === 'Flat Deal') {
      data = 'Custom Deal';
    }

    return data;
};

const transformedData = (dealsWiseAggregateData) => {
  try {
    return (dealsWiseAggregateData && Object.keys(dealsWiseAggregateData).length > 0)
      ? Object.values(dealsWiseAggregateData).map(item => ({
          asset: item.deal_label,
          percent: parseFloat(item.deal_percentage_share)
        }))
      : [];
  } catch (error) {
    console.error('Error transforming data:', error);
    return [];
  }
};


const DealsSummary = ({
  fetchDealSummary = () => {},
  dealsSummaryData = {},
  selectedDuration = "",
  fetchDealsWiseAggregateData = () => {},
  dealsWiseAggregateData = {},
}) => {
  // const getDealsSummaryData1 = {
  //   //mock data
  //   summary: {
  //     seat_sold: 317,
  //     avg_discounted_offer: "6.82%",
  //     amount_spent: 1753,
  //     total_revenue_generated: 25700,
  //   },
  // };
  const barChartFilled = () => {
    const dealTypeToColor = {
      'EARLY_BIRD': '#27AE5F',
      'LAST_MINUTE': '#FED533',
      'SEAT_LEVEL': '#58CCDE',
      'FLAT_DEAL': '#B3325D',
      'NEW_USER': '#EB5757',
    };    
    
    const transformed = transformedData(dealsWiseAggregateData);
    let colors = [];
    if(Object.keys(transformed).length > 0) {
      colors = transformed.map(item => dealTypeToColor[item.asset] || '#CCCCCC');
    }
    return colors;
   }
  
  const [options, setOptions] = useState({
    data: [],
    series: [
      {
        type: "pie",
        labelKey: "asset",
        angleKey: "percent",
        innerRadiusRatio: 0.6,
        fills: barChartFilled(),
        tooltip: {
          enabled: false,
        },
      },
    ],
  });

  useEffect(() => {
    setOptions({
      data: [],
      series: [
        {
          type: "pie",
          labelKey: "asset",
          angleKey: "percent",
          innerRadiusRatio: 0.6,
          fills: barChartFilled(),
          tooltip: {
            enabled: false,
          },
        },
      ],
    })
  }, [dealsWiseAggregateData]);

  const compareArrays = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
      return false;
    }
  
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }
  
    return true;
  };

  useEffect(() => {
    const transformed = transformedData(dealsWiseAggregateData);
      if (!compareArrays(transformed, options.data)) {//this line added to avoid callstack maximum exceed error fix
      setOptions((prevOptions) => ({ ...prevOptions, data: transformed }));
      // barChartFilled();
    }
    // setOptions((prevOptions) => ({ ...prevOptions, data: transformed }));
  }, [dealsWiseAggregateData]);

  const getElementName = (item) => {
    if (item === "seat_sold") {
      return "Seats sold";
    }
    if (item === "total_revenue_generated") {
      return "Total GMV generated";
    }
    if (item === "avg_discounted_offer") {
      return "Avg discount offered";
    }
    if (item === "amount_spent") {
      return "Amount spent on deals";
    }
  };

  const formatValue = (key, value) => {
    if (key === "amount_spent" || key === "total_revenue_generated") {
      const formattedValue = Number(value).toLocaleString('en-IN', {
        style: 'currency',
        currency: 'INR'
      });
      return formattedValue !== '₹NaN'  ? formattedValue : '-';
    } else {
      return value || '-';
    }
  };

  let temp = [];
  if(Object.keys(dealsSummaryData).length > 0) {
    temp.push(["seat_sold", dealsSummaryData["summary"].seat_sold]);
    temp.push(["avg_discounted_offer", dealsSummaryData["summary"].avg_discounted_offer]);
    temp.push(["amount_spent", dealsSummaryData["summary"].amount_spent]);
    temp.push(["total_revenue_generated", dealsSummaryData["summary"].total_revenue_generated]);
  }
 
  return (
     <div className="row dealContainer">
        <div className="pieChart col-xs-3">
          <AgChartsReact options={options} />
        </div>
        <div className="barChartPercentContainer">
        {options && options.data && options.data.length > 0 && (
            formatAssetStrings(options.data)
              .map((elem, index) => (
                <div key={index} className="barChartText">
                  <div>{elem}</div>
                </div>
              ))
          )}
        </div>
        {Object.keys(dealsSummaryData).length > 0 && (
        <div className="dealSummaryBlck ">
        
          <div className="summaryHead">Summary</div>
          <div className="row">
            
            {temp.map(
              (elem, index) => (
                <div className="col-xs-6 dealBlock" key={index}>
                  <div className="deal">
                    <div className="dealText1">{getElementName(elem[0])} </div>
                    <div className="dealValue">{formatValue(elem[0], elem[1])}</div>                   
                  </div>
                </div>
              )
            )}
          </div>
        </div>)}
      </div>
    
  );
};

export default DealsSummary;
